import * as React from 'react';

export interface BroedtekstProps {
  children?: string;
}

export function Broedtekst(props: BroedtekstProps) {
  return (
    <p className='broedtekst'>{props.children}</p>
  );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/Broedtekst.tsx